<style lang="less" scoped>
    .dashboard-container {
        height: 100%;
    }
    .dashboard-container div {
        // border:1px solid;
        box-sizing: border-box;
    }
    .background {
        background: rgba(255, 255, 255, 1);
        box-shadow: 3px 2px 11px 6px rgba(0, 0, 0, 0.06);
        border-radius: 1.25rem;
        border: 1px solid rgba(230, 230, 230, 1);
    }
    .left {
        //width: 18.75rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 300px;
        margin-right: 16px;
    }
    .margin-7 {
        margin: .7rem .7rem;
    }
    .middle {
        //width: 70rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        flex: 1;
    }
    .right {
        width: 415px/* 415/16 */;
        height: 100%;
        border-radius: 1.25rem 0 0 1.25rem;
        margin-left: .7rem;
        padding: 20px 18px;
        display: flex;
        flex-direction: column;
        overflow-y: auto; // justify-content: space-between;
        .right-top {
            // height:30%;
            margin-bottom: 1.25rem/* 20/16 */
            ;
        }
        .right-middle {
            margin-bottom: 1.25rem/* 20/16 */
            ;
        }
        .charge-table {
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: .75rem/* 12/16 */
            ;
            color: #8F9BB3;
            font-weight: 500;
            border-width: .0625rem/* 1/16 */
            ;
            border-color: #E8E8E8;
            border-collapse: collapse;
            height: 13.125rem/* 210/16 */
            ;
        }
        .charge-table td {
            border-width: .0625rem/* 1/16 */
            ;
            padding: .1rem/* 6/16 */
            ;
            width: 5.875rem/* 94/16 */
            ;
            border-style: solid;
            border-color: #E8E8E8;
            text-align: center;
        }
        .charge-table-title {
            float: right;
            font-size: 1.125rem/* 18/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
        }
        .line {
            float: right;
            clear: both;
            margin-bottom: 1.25rem/* 20/16 */
            ;
        }
        .echarts-line {
            // padding-top:1rem;
            clear: both;
        }
    }
    .logo-div {
        height: 5rem;
        margin: .7rem .7rem .7rem 0;
        line-height: 5rem; // text-align: center;
        .logo-title {
            font-size: 1rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
        }
        .logo-img {
            margin: 25px 10px 0px 33px;
            width: 29px;
            height: 30px;
        }
    }
    .pile-mes-div {
        height: 26%; //12.5rem;
        //margin: .7rem .7rem .7rem 0;
        margin: 3.7rem .7rem .7rem 0;
        .title-top {
            margin: 1.25rem 0 0 1.87rem;
        }
        .pile-num {
            display: block; // height:3.125rem;
            font-size: 2.25rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(183, 128, 243, 1);
            line-height: 3.125rem;
            margin: .625rem 0 0 1.875rem;
        }
        .pile-unit {
            display: block;
            width: 1.25rem;
            height: 1.75rem/* 28/16 */
            ;
            font-size: 1.25rem/* 20/16 */
            ;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(183, 128, 243, 1);
            line-height: 1.75rem/* 28/16 */
            ;
            margin: 1.5625rem 0 0 .5625rem/* 9/16 */
            ;
        }
        .space-around {
            justify-content: space-around;
            margin-top: 50px;
        }
        .pile-info {
            display: block;
            height: 2.25rem/* 36/16 */
            ;
            font-size: 1.5625rem/* 25/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(74, 74, 74, 1);
            line-height: 2.25rem/* 36/16 */
            ;
        }
        .pile-info-unit {
            display: block;
            font-size: .8125rem/* 13/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(74, 74, 74, 1);
        }
        .charging-margin {
            margin: .31rem 0 0 0;
        }
        .charging-unit-margin {
            margin: 1rem 0 0 .31rem;
        }
        .standby-margin {
            margin: .31rem 0 0 0;
        }
        .standby-unit-margin {
            margin: 1rem 0 0 .31rem;
        }
    }
    .charge-mes-div {
        display: flex;
        flex-direction: column;
        height: 40%; //25rem;
        //margin: .7rem .7rem .7rem 0;
        margin: 3.7rem .7rem .7rem 0;
        .btn-div {
            justify-content: flex-end;
            margin: .625rem 0 0 6.25rem/* 100/16 */
            /* 10/16 */
            ;
            padding: 10px;
        }
        .charge-btn {
            cursor: pointer;
            width: 3.125rem/* 50/16 */
            ;
            font-size: .875rem/* 14/16 */
            ;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(163, 169, 175, 1);
            text-align: center;
        }
        .charge-info-div {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            margin: 3.125rem 1.25rem .625rem 1.25rem;
            .space-between {
                display: flex;
                justify-content: space-between;
                height: 2.5rem/* 40/16 */
                ;
                span {
                    display: block;
                }
            }
        }
    }
    .fault-pile-mes-div {
        height: 36%; //12.5rem;
        margin: .7rem .7rem .7rem 0;
        .title-top {
            margin: 1.25rem 0 0 1.87rem;
        }
        .pile-num {
            display: block; // height:3.125rem;
            font-size: 2.25rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(252, 101, 101, 1);
            line-height: 3.125rem;
            margin: .625rem 0 0 1.875rem;
        }
        .pile-unit {
            display: block;
            width: 1.25rem;
            height: 1.75rem/* 28/16 */
            ;
            font-size: 1.25rem/* 20/16 */
            ;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(252, 101, 101, 1);
            line-height: 1.75rem/* 28/16 */
            ;
            margin: 1.5625rem 0 0 .5625rem/* 9/16 */
            ;
        }
        .space-around {
            justify-content: space-around;
            margin-top: 50px;
        }
        .pile-info {
            display: block;
            height: 2.25rem/* 36/16 */
            ;
            font-size: 1.5625rem/* 25/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(74, 74, 74, 1);
            line-height: 2.25rem/* 36/16 */
            ;
        }
        .pile-info-unit {
            display: block;
            font-size: .8125rem/* 13/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(74, 74, 74, 1);
        }
        .charging-margin {
            margin: .31rem 0 0 0;
        }
        .charging-unit-margin {
            margin: 1rem 0 0 .31rem;
        }
        .standby-margin {
            margin: .31rem 0 0 0;
        }
        .standby-unit-margin {
            margin: 1rem 0 0 .31rem;
        }
    }
    .middle-top-div {
        justify-content: space-around;
        .small-title {
            margin: .625rem 0 0 1.875rem/* 30/16 */
            ;
        }
        .middle-mes-div {
            display: block;
            font-size: 1.625rem/* 26/16 */
            ;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            margin: .3125rem 0 0 1.875rem/* 30/16 */
            ;
        }
        .middle-unit-div {
            display: block;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            margin: 1rem 0 0 .625rem/* 10/16 */
            ;
        }
        .order-add-height {
            height: 200px !important;
        }
    }
    .middle-top-div .background {
        width: 31%;
        border-radius: 0 0 1.25rem 1.25rem;
        height: 4.875rem;
        margin: 0 .2rem .2rem .2rem;
    }
    .middle-middle-div {
        box-shadow: 3px 2px 11px 6px rgba(0, 0, 0, 0.06);
        border-radius: 1.25rem;
        height: 55%; //37.5rem;
        margin: .7rem;
    }
    .middle-bottom-div {
        height: 16.5rem;
        .echarts-line {
            padding-top: 1rem;
        }
    }
    #mianMapDom {
        height: 100%;
        width: 100%;
        border-radius: 1.25rem;
    }
    .small-title {
        height: 1rem;
        font-size: .75rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(143, 155, 179, 1);
        line-height: 1rem;
    }
    .big-title {
        font-size: 1.125rem/* 18/16 */
        ;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
    }
    .line {
        width: 1.5625rem/* 25/16 */
        ;
        height: .125rem/* 2/16 */
        ;
        background: linear-gradient(205deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
        border-radius: .125rem/* 2/16 */
        ;
    }
    .day-line {
        border-bottom: .125rem solid;
        border-bottom-color: linear-gradient(204deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
    }
    .month-line {
        border-bottom: .125rem solid;
        border-bottom-color: linear-gradient(204deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
    }
    .all-line {
        border-bottom: .125rem solid;
        border-bottom-color: linear-gradient(204deg, rgba(183, 128, 243, 1) 0%, rgba(89, 189, 255, 1) 100%);
    }
    .btn-date {
        font-size: 1.125rem/* 18/16 */
        ;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        padding: 1rem 0 1rem 1.87rem;
    }
    .date-div {
        height: 10%; //12.5rem;
        margin: .7rem .7rem .7rem 0;
        .title-top {
            margin: 1.25rem 0 0 1.87rem;
        }
    }
    .totle-title {
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #8F9BB3;
        line-height: 16px;
        text-align: right;
        margin-top: 30px;
    }
    .btn-logo-div {
        height: 40px;
        line-height: 40px;
        margin-bottom: 5px;
    }
    .logo-title-div {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
    }
    .logo-href-div {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #B780F3;
    }
    .change-right-div {
        margin-left: 52px;
        height: 67px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #24A71E;
        line-height: 67px;
    }
    .change-error-div {
        margin-left: 52px;
        height: 67px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FC297D;
        line-height: 67px;
    }
    .change-img-div {
        margin-left: 10px;
        margin-top: 25px;
    }
    .change-imgo-div {
        margin-left: 40px;
    }
</style>
<template>
    <div class="dashboard-container flex">
        <div class="left">
            <div class="logo-div background flex">
                <div><img class="logo-img" :src="imgSrc" alt=""></div>
                <div class="logo-title">{{dealName}}</div>
            </div>
            <div class="pile-mes-div background">
                <div class="small-title title-top">充电桩总数</div>
                <div class="flex">
                    <span class="pile-num">{{pileData.pileCount}}</span><span class="pile-unit">台</span>
                </div>
                <div class="flex space-around">
                    <div>
                        <div class="small-title">充电中</div>
                        <div class="flex">
                            <span class="pile-info charging-margin">{{pileData.chargingCount}}</span><span class="pile-info-unit charging-unit-margin">台</span>
                        </div>
                    </div>
                    <div>
                        <div class="small-title">待机中</div>
                        <div class="flex">
                            <span class="pile-info standby-margin">{{pileData.freeCount}}</span><span class="pile-info-unit standby-unit-margin">台</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="charge-mes-div background">
                <div class="flex btn-div">
                    <div class="charge-btn" :class="{ 'day-line': type == '-1' }" @click="getLeftOrderDto('-1')">昨天</div>
                    <div class="charge-btn" :class="{ 'month-line': type == '30' }" @click="getLeftOrderDto('30')">当月</div>
                    <div class="charge-btn" :class="{ 'all-line': type == '0' }" @click="getLeftOrderDto('0')">累计</div>
                </div>
                <div class="flex-1"></div>
                <div class="charge-info-div">
                    <div class="space-between"><span class="small-title">充电金额</span><span>{{leftorderdto.actFee}}元</span></div>
                    <div class="space-between"><span class="small-title">充电量</span><span>{{leftorderdto.chargeVal}}&nbsp;KWH</span></div>
                    <div class="space-between"><span class="small-title">充电时长</span><span>{{leftorderdto.chargeHour}}小时</span></div>
                    <div class="space-between"><span class="small-title">订单量</span><span>{{leftorderdto.orderCount}}单</span></div>
                </div>
            </div>
            <!-- <div class="fault-pile-mes-div background">
                <div class="small-title title-top">异常桩</div>
                <div class="flex">
                    <span class="pile-num">{{pileData.unKnowCount}}</span><span class="pile-unit">台</span>
                </div>
                <div class="flex space-around">
                    <div>
                        <div class="small-title">离网桩</div>
                        <div class="flex">
                            <span class="pile-info charging-margin">{{pileData.offLineCount}}</span><span class="pile-info-unit charging-unit-margin">台</span>
                        </div>
                    </div>
                    <div>
                        <div class="small-title">故障桩</div>
                        <div class="flex">
                            <span class="pile-info standby-margin">{{pileData.errorCount}}</span><span class="pile-info-unit standby-unit-margin">台</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="middle">
            <div class="middle-top-div flex">
                <!-- <div class="background" :class="{'order-add-height':orderFlag == true}" @click="handleOrderHeight"> -->
                <div class="background" :class="{'order-add-height':orderFlag == true}" @click="handleOrderHeight">
                    <div class="small-title">订单金额<span></span></div>
                    <div class="num-div flex"><span class="middle-mes-div font-bold">{{pileData.actFee}}</span><span class="middle-unit-div">元</span></div>
                    <div class="flex">
                        <div class="change-right-div" v-if="orderFlag && pileData.yestActFee >= 0">{{pileData.yestActFee}}</div>
                        <div class="change-error-div" v-if="orderFlag && pileData.yestActFee <0">{{pileData.yestActFee}}</div>
                        <div class="change-img-div" v-if="orderFlag && pileData.yestActFee >=0"><img src="../../assets/main/up.png" class="menu-collpose-icon" width="16" height="18"></div>
                        <div class="change-img-div" v-if="orderFlag && pileData.yestActFee <0"><img src="../../assets/main/fall.png" class="menu-collpose-icon" width="16" height="18"></div>
                    </div>
                    <div class="change-imgo-div" v-if="orderFlag && pileData.yestActFee >=0"><img src="../../assets/main/up1.png" class="menu-collpose-icon" width="176" height="43"></div>
                    <div class="change-imgo-div" v-if="orderFlag && pileData.yestActFee <0"><img src="../../assets/main/fall1.png" class="menu-collpose-icon" width="176" height="43"></div>
                </div>
                <div class="background" :class="{'order-add-height':chargeFlag == true}" @click="handleChargeHeight">
                    <div class="small-title">充电量<span></span></div>
                    <div class="flex"><span class="middle-mes-div font-bold">{{pileData.chargeVal}}</span><span class="middle-unit-div">KWH</span></div>
                    <div class="flex">
                        <div class="change-right-div" v-if="chargeFlag && pileData.yestActFee >= 0">{{pileData.yestChargeVal}}</div>
                        <div class="change-error-div" v-if="chargeFlag && pileData.yestActFee <0">{{pileData.yestChargeVal}}</div>
                        <div class="change-img-div" v-if="chargeFlag && pileData.yestActFee >=0"><img src="../../assets/main/up.png" class="menu-collpose-icon" width="16" height="18"></div>
                        <div class="change-img-div" v-if="chargeFlag && pileData.yestActFee <0"><img src="../../assets/main/fall.png" class="menu-collpose-icon" width="16" height="18"></div>
                    </div>
                    <div class="change-imgo-div" v-if="chargeFlag && pileData.yestActFee >=0"><img src="../../assets/main/up1.png" class="menu-collpose-icon" width="176" height="43"></div>
                    <div class="change-imgo-div" v-if="chargeFlag && pileData.yestActFee <0"><img src="../../assets/main/fall1.png" class="menu-collpose-icon" width="176" height="43"></div>
                </div>
                <div class="background">
                    <div class="small-title">单桩平均月收益</div>
                    <div class="flex"><span class="middle-mes-div">{{pileData.pileAvgMonthFee}}</span><span class="middle-unit-div">元</span></div>
                </div>
            </div>
            <div class="middle-middle-div">
                <div id="mianMapDom"></div>
            </div>
            <div class="middle-bottom-div margin-7">
                <div class="big-title">月充电趋势（千瓦时）</div>
                <div class="line"></div>
                <div class="echarts-line">
                    <echarts-line v-if="bigFlag" :lineId="chargeLine" :xAxis="xAxisCharge" :data="chargeData" lineHeight="16rem" legendPosition="left" :lineColor="middleLineColor" tilt="0" :legendData="bigLegendData"></echarts-line>
                </div>
            </div>
        </div>
        <div class="right background">
            <div class="right-top">
                <div class="charge-table-title">最近概况</div>
                <div class="line"></div>
                <table class="charge-table" width="100%">
                    <tr>
                        <td></td>
                        <td>充电金额</td>
                        <td>充电量</td>
                        <td>充电车次</td>
                        <td>充电时长</td>
                    </tr>
                    <tr>
                        <td>昨天</td>
                        <td>{{lastDay.actFee}}</td>
                        <td>{{lastDay.chargeVal}}</td>
                        <td>{{lastDay.orderCount}}</td>
                        <td>{{lastDay.chargeHour}}</td>
                    </tr>
                    <tr>
                        <td>前天</td>
                        <td>{{beforeYesterDay.actFee}}</td>
                        <td>{{beforeYesterDay.chargeVal}}</td>
                        <td>{{beforeYesterDay.orderCount}}</td>
                        <td>{{beforeYesterDay.chargeHour}}</td>
                    </tr>
                    <!-- <tr>
                            <td>昨日此时</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>近90日平均</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr> -->
                    <tr>
                        <!-- <td>历史最高</td> -->
                        <td rowspan="2">历史最高</td>
                        <td>{{historyMax.actFeeMax}}</td>
                        <td>{{historyMax.chargeValMax}}</td>
                        <td>{{historyMax.orderCountMax}}</td>
                        <td>{{historyMax.chargeHourMax}}</td>
                    </tr>
                    <tr>
                        <td>{{historyMax.actFeeMaxDay}}</td>
                        <td>{{historyMax.chargeValMaxDay}}</td>
                        <td>{{historyMax.orderCountMaxDay}}</td>
                        <td>{{historyMax.chargeMinMaxDay}}</td>
                    </tr>
                </table>
            </div>
            <div class="right-middle">
                <div class="charge-table-title">最新订单</div>
                <div class="line"></div>
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <div class="right-bottom">
                <div class="charge-table-title">24小时充电桩使用图</div>
                <div class="line"></div>
                <div class="echarts-line">
                    <echarts-line v-if="smallFlag" :lineId="pileLine" :xAxis="xAxisPileUse" :data="pileUseData" lineHeight="12rem" legendPosition="right" :lineColor="rightLineColor" tilt="0" :legendData="smallLegendData"></echarts-line>
                </div>
                <div class="totle-title">截止日期:{{leftorderdto.updateDate}}</div>
                <div class="btn-logo-div flex">
                    <div class="flex-1 flex">
                        <img src="../../assets/menu-img/user-icon (1).png" class="user-logo-icon" width="40">
                        <div class="logo-title-div">桩到家团队荣誉出品</div>
                    </div>
                    <div class="flex-1" style="text-align: right">
                        <a class="logo-href-div" href="https://support.qq.com/products/135447?" target="_blank">申请功能</a>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
        <div style="display:none;">
            <info-window-div ref="infowindow" @close-info-window="closeInfo"></info-window-div>
        </div>
    </div>
</template>
<script>
    import './rem.js'
    import gps from "./gps.js";
    import echartsLine from './echarts-line';
    import infoWindowDiv from './info-window'
    import pageConfig from './page-config';
    import useStation from '../../assets/dashboard/启用.png'
    import noUseStation from '../../assets/dashboard/未启用.png'
    import joinIcon from '../../assets/dashboard/juhe.png'
    export default {
        components: {
            echartsLine,
            infoWindowDiv,
        },
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                map: null,
                chargeLine: 'chargeLine',
                pileLine: 'pileLine',
                xAxisPileUse: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
                xAxisCharge: [],
                chargeData: {
                    thisData: [],
                    lastData: [],
                    lastTwoMonth: [],
                },
                pileUseData: {
                    thisData: [],
                    lastData: []
                },
                bigLegendData: ['当月充电量', '上月充电量','前两月充电量'],
                smallLegendData: ['今日充电', '昨日充电'],
                bigFlag: false,
                smallFlag: false,
                middleLineColor: ['#BC8BFD', '#62C9F5','#809FF9'],
                rightLineColor: ['#6DC8EC', '#FF99C3'],
                operates: {
                    width: 100,
                    fixed: "right",
                    list: []
                }, // 列操作按钮
                pileData: {},
                leftorderdto: {},
                type: '-1',
                historyMax: {},
                lastDay: {},
                beforeYesterDay: {},
                map: {},
                infoWindow: {},
                orderFlag: false,
                chargeFlag: false,
                dealName: '',
                imgSrc: ''
            }
        },
        methods: {
            init() {
                this.initmap();
                this.getPileData();
                this.getLeftOrderDto("1");
                this.getDayorderdto();
                this.getChargeLineData();
                this.getPileOrderData();
                this.getPileUseData();
                let _ = this;
                var obj = {
                    dealNo: _.$store.state.userInfo.dealNo
                }
                _.$H.get(_, _.$A.pile.findByDealNo, obj).then(res => {
                    _.dealName = res.data.data.dealName;
                    _.imgSrc = res.data.data.imgPath
                })
            },
            initmap() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.map = new AMap.Map('mianMapDom', {
                    resizeEnable: true,
                    zoom: 9, //级别
                    center: [121.314358, 30.877824], //中心点坐标
                    mapStyle: 'amap://styles/whitesmoke', //设置地图的显示样式
                });
                _.infoWindow = new AMap.InfoWindow({
                    isCustom: true,
                    offset: new AMap.Pixel(-3, -12),
                    content: _.$refs.infowindow.$el,
                });
                _.map.clearMap();
                _.$H.post(_, _.$A.dashboard.middlestations, obj).then(res => {
                    const markerData = res.data.data;
                    if (markerData) {
                        let mapMarkers = [];
                        markerData.forEach(item => {
                            if (_.$U.notEmpty(item.rtLat) && _.$U.notEmpty(item.rtLon)) {
                                let icon = '';
                                item.stationStatus == "02" ? icon = useStation : icon = noUseStation;
                                const lon = parseFloat(item.rtLon).toFixed(6);
                                const lat = parseFloat(item.rtLat).toFixed(6);
                                const gdLonlat = gps.gcj_encrypt(parseFloat(lat), parseFloat(lon));
                                let marker = '';
                                marker = new AMap.Marker({
                                    map: _.map,
                                    position: [gdLonlat.lon.toFixed(6), gdLonlat.lat.toFixed(6)],
                                    offset: new AMap.Pixel(-10, -12),
                                    icon: icon
                                    // clickable: true,
                                });
                                AMap.event.addListener(marker, 'click', function(e) {
                                    _.$refs.infowindow.$emit('update', item);
                                    _.infoWindow.open(_.map, marker.getPosition());
                                })
                                mapMarkers.push(marker);
                            }
                        })
                        var sts = [{
                            url: joinIcon,
                            size: new AMap.Size(32, 32),
                            offset: new AMap.Pixel(-16, -16),
                            textColor: '#fff'
                        }];
                        _.mapCluster = new AMap.MarkerClusterer(_.map, mapMarkers, {
                            styles: sts,
                            gridSize: 80
                        });
                    }
                })
            },
            getPileData() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_, _.$A.dashboard.pileandorderdto, obj).then(res => {
                    _.pileData = res.data.data;
                })
            },
            getLeftOrderDto(type) {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.type = type;
                obj.type = type;
                _.$H.post(_, _.$A.dashboard.leftorderdto, obj).then(res => {
                    _.leftorderdto = res.data.data;
                })
            },
            getDayorderdto() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_, _.$A.dashboard.dayorderdto, obj).then(res => {
                    _.historyMax = res.data.data.dayOrderMap.historyMax;
                    _.lastDay = res.data.data.dayOrderMap.lastDay;
                    _.beforeYesterDay = res.data.data.dayOrderMap.beforeYesterDay;
                })
            },
            getChargeLineData() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_, _.$A.dashboard.monthtrend, obj).then(res => {
                    if (res.data.data.monthTrendMap.thisMonth) {
                        res.data.data.monthTrendMap.thisMonth.forEach((item, index) => {
                            //_.xAxisCharge.push(index+1+'');
                            _.chargeData.thisData.push(item.chargeVal);
                        })
                    }
                    if (res.data.data.monthTrendMap.lastMonth) {
                        res.data.data.monthTrendMap.lastMonth.forEach(item => {
                            _.xAxisCharge.push(item.chargeDay)
                            _.chargeData.lastData.push(item.chargeVal);
                        })
                    }
                    if (res.data.data.monthTrendMap.lastTwoMonth) {
                        res.data.data.monthTrendMap.lastTwoMonth.forEach(item => {
                            //_.xAxisCharge.push(item.chargeDay)
                            _.chargeData.lastTwoMonth.push(item.chargeVal);
                        })
                    }
                    _.bigFlag = true;
                })
            },
            getPileOrderData() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                obj.pageNum = 0;
                obj.pageSize = 5;
                obj.corpNo = _.$store.state.corpNo;
                obj.pileType = '02';
                _.$H.get(_, _.$A.order.pileorder, obj).then(res => {
                    _.tableData = res.data.data.content || [];
                })
            },
            getPileUseData() {
                let _ = this;
                let dealerNo = this.$store.state.userInfo.dealNo;
                let obj = {};
                if (dealerNo) {
                    obj.dealerNo = dealerNo;
                }
                _.$H.post(_, _.$A.dashboard.daytrend, obj).then(res => {
                    if (res.data.data.dayTrendMap.thisDay) {
                        Object.keys(res.data.data.dayTrendMap.thisDay).forEach((key) => {
                            // _.xAxisPileUse.push(key);
                            _.pileUseData.thisData.push(res.data.data.dayTrendMap.thisDay[key].length);
                        })
                    }
                    if (res.data.data.dayTrendMap.lastDay) {
                        Object.keys(res.data.data.dayTrendMap.lastDay).forEach((key) => {
                            _.pileUseData.lastData.push(res.data.data.dayTrendMap.lastDay[key].length);
                        })
                    }
                    _.smallFlag = true;
                })
            },
            closeInfo(val) {
                this.infoWindow.close();
            },
            handleOrderHeight() {
                this.orderFlag = !this.orderFlag;
            },
            handleChargeHeight() {
                this.chargeFlag = !this.chargeFlag;
            }
        },
        mounted() {
            this.init();
        },
        computed: {
            menuCollapse() {
                return this.$store.state.menuCollapse;
            },
        },
        watch: {
            menuCollapse(newVal, oldVal) {
                let _ = this;
                _.bigFlag = false;
                _.smallFlag = false;
                setTimeout(function() {
                    _.bigFlag = true;
                    _.smallFlag = true;
                }, 100)
            }
        },
    }
</script>